module.exports = __webpack_public_path__ + "img/pohled_z_balkonu_3.63411b74.jpg";